import React from 'react';

var Context = function Context() {
  var contexts = {};

  var createContext = function createContext(key, initialValue) {
    contexts[key] = React.createContext(initialValue);
    return contexts[key];
  };

  var getContext = function getContext(key, initialValue) {
    return contexts[key] || createContext(key, initialValue);
  };

  return {
    getContext: getContext
  };
};

export default Context();